// FIX AUTO SCROLL ON LOAD (ANCHORED URL)
// RESPONSIVE VIDEO!
// PAUSE OUT-OF-VIEW VIDEO
// SCROLL-TO ANIMATION FOR ANCHOR LINKS
// SLIDER (SWIPER JS)
// DETAILS OPEN (S + M)


//
// =FIX AUTO SCROLL ON LOAD (ANCHORED URL)
// --------------------------------------------------

window.addEventListener('load', () => {
  if (window.location.href.indexOf('#signup') > -1) {
    $("html, body").animate({scrollTop: $('#signup').offset().top }, 900);
  }
});


//
// =RESPONSIVE VIDEO!
// --------------------------------------------------

const vid = document.getElementById('msdw-video-responsive');

function loadVideo() {
  var sm = window.matchMedia( "(min-width: 0px) and (max-width: 599px)" ), // Standard def (mp4, 640x360)
      md = window.matchMedia( "(min-width: 600px) and (max-width: 899px)" ), // Standard def (mp4, 960x540)
      lg = window.matchMedia( "(min-width: 900px) and (max-width: 1199px)" ), // High def (mp4, 1280x720)
      xl = window.matchMedia( "(min-width: 1200px) and (max-width: 99999px)" ); // High def 1080 (mp4, 1920x1080)

  sm.addEventListener("change", changeVideoSize);
  md.addEventListener("change", changeVideoSize);
  lg.addEventListener("change", changeVideoSize);
  xl.addEventListener("change", changeVideoSize);

  if      (sm.matches) { changeVideoSize('sm') }
  else if (md.matches) { changeVideoSize('md') }
  else if (lg.matches) { changeVideoSize('lg') }
  else if (xl.matches) { changeVideoSize('xl') }
}

function changeVideoSize(size){
  const videoSource = $("#msdw-video-responsive source");
  videoSource.attr("src", videoSource.attr("data-video-"+size));
  vid.autoplay = true;
  vid.load();
  // console.log(videoSource.attr("src"));
}

if (document.contains(vid)) {
  document.addEventListener('DOMContentLoaded', loadVideo);
  document.addEventListener('resize', loadVideo);
  vid.onloadeddata = () => vid.classList.add('msdw-video-loaded');
}


//
// =PAUSE OUT-OF-VIEW VIDEO
// --------------------------------------------------

const videos = document.querySelectorAll("video");

const config = {
  rootMargin: '0px -100px',
  threshold: 0
}

const callback = (entries) => {
  entries.forEach((entry) => {
    if (!entry.isIntersecting) {
      entry.target.pause();
      // console.log('Exit video');
    } else {
      entry.target.play();
      // console.log('Enter video');
    }
  });
}

const vidsObserver = new IntersectionObserver(callback, config);

videos.forEach(element => {
  vidsObserver.observe(element);
});


//
// =SCROLL-TO ANIMATION FOR ANCHOR LINKS
// --------------------------------------------------

$('.msdw-page-scroll').click(function() {
  if (location.pathname.replace(/^\//,'') == this.pathname.replace(/^\//,'') && location.hostname == this.hostname) {
    var target = $(this.hash);
    target = target.length ? target : $('[name=' + this.hash.slice(1) +']');
    if (target.length) {
      var offsetValue = 0;
      if ( window.innerWidth <= 767 ) {
        offsetValue;
        // console.log(offsetValue);
      } else {
        offsetValue = 59;
        // console.log(offsetValue);
      }

      $('html,body').animate({
        scrollTop: target.offset().top - offsetValue
      }, 900);
      return false;
    }
  }
});


//
// =SLIDER (SWIPER JS)
// --------------------------------------------------

var swiper1 = new Swiper('#swiper-1', {
  pagination: false,
  breakpoints: {
    320: {
      slidesPerView: 1.45,
      spaceBetween: 10
    },
    600: {
      slidesPerView: 2.27,
      spaceBetween: 15
    },
    900: {
      slidesPerView: 2.33,
      spaceBetween: 20,
    },
    1200: {
      slidesPerView: 4,
      spaceBetween: 20,
    }
  },
});

var swiper2_DE = new Swiper('#swiper-2-de', {
  pagination: false,
  navigation: {
    nextEl: ".msdw-swiper-button-next",
    prevEl: ".msdw-swiper-button-prev",
  },
  breakpoints: {
    320: {
      slidesPerView: 1,
      spaceBetween: 10
    },
    600: {
      slidesPerView: 2,
      spaceBetween: 90
    },
    900: {
      slidesPerView: 3,
      spaceBetween: 20,
    },
    1200: {
      slidesPerView: 4,
      spaceBetween: 20,
    }
  },
});

var swiper2_not_DE = new Swiper('#swiper-2-not-de', {
  pagination: false,
  navigation: {
    nextEl: ".msdw-swiper-button-next",
    prevEl: ".msdw-swiper-button-prev",
  },
  breakpoints: {
    320: {
      slidesPerView: 1,
      spaceBetween: 10
    },
    600: {
      slidesPerView: 2,
      spaceBetween: 90
    },
    900: {
      slidesPerView: 3,
      spaceBetween: 20,
    },
    1200: {
      slidesPerView: 3,
      spaceBetween: 20,
    }
  },
});

var swiper3 = new Swiper('#swiper-3', {
  pagination: false,
  breakpoints: {
    900: {
      slidesPerView: 1.725,
      spaceBetween: 20,
    },
    1200: {
      slidesPerView: 3,
      spaceBetween: 20,
    }
  },
});


//
// =DETAILS OPEN (S + M)
// --------------------------------------------------

const details = document.querySelectorAll('details');
let mql = window.matchMedia("(max-width: 899px)");

function startDetails() {
  if(mql.matches) {
    details.forEach(d => d.open = true );
  } else {
    details.forEach(d => d.open = false );
  }
}

document.addEventListener('DOMContentLoaded', startDetails);
window.onresize = startDetails;
